import { Box, Flex, Text, WrapItem } from "@chakra-ui/react";
import { Layers } from "lucide-react";
import { LayerButton } from "./LayerButton";

type LayerItem = {
  label: string;
  icon: JSX.Element;
  onClick: () => void;
  isSelected: boolean;
};

type LayerSectionProps = {
  title: string;
  items: LayerItem[];
  emptyItemsText?: string;
};

export const LayerSection = ({
  title,
  items,
  emptyItemsText,
}: LayerSectionProps) => (
  <Box color="gray.700" mt="16px">
    <Text
      fontWeight="bold"
      fontSize="sm"
      mb={2}
      color="newBlue.500"
      borderBottom="1px"
      borderColor="newBlue.500"
    >
      {title}
    </Text>
    {!items.length ? (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        pt={2}
        gap={"2px"}
      >
        <Layers />
        <Text fontSize="12px" fontWeight="light" px={6}>
          {emptyItemsText}
        </Text>
      </Flex>
    ) : (
      <Flex wrap="wrap" justify="flex-start" gap={2} borderRadius={"8px"}>
        {items?.map(({ label, icon, isSelected, onClick }) => (
          <WrapItem key={label} paddingY={2}>
            <LayerButton
              label={label}
              icon={icon}
              isSelected={isSelected}
              onClick={onClick}
            />
          </WrapItem>
        ))}
      </Flex>
    )}
  </Box>
);
